import React from "react";
import styles from "./Table.module.css";
import Icon from "../icon/Icon";
import CheckBox from "../checkbox/CheckBox";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import RadioButton from "../radiobutton/RadioButton";
import Modale from "../modale/Modale";
import Utils from "../../utils/Utils";
import OggettiUtili from "../../utils/OggettiUtili";
import Button from "../button/Button";
import SessioneUtente from "../../sessionManager/SessioneUtente";
import Ruoli from "../../utils/Ruoli.json";
class Table extends React.Component {
    state = {
        page: this.props.page ? this.props.page : 0,
        tableLenght: this.props.tableLenght,
        totalElements: this.props.totalElements
            ? this.props.totalElements
            : this.props.rows.length,
        totalPages: this.props.totalPages,
        rows: this.props.rows,
        initialRows: this.props.rows,
        cols: this.props.cols,
        homepage: this.props.homepage,
        bigTable: this.props.bigTable,
        lengthEditable: this.props.lengthEditable,
        selected: null,
        selezioneFromRadioButton: null,
        editedSize: 10,
    };

    constructor(props) {
        super(props);
        this.renderCell = this.renderCell.bind(this);
        this.handleChangess = this.handleChangess.bind(this);
        this.handleChangessMonckey = this.handleChangessMonckey.bind(this);
        this.handleRadioClick = this.handleRadioClick.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleIcon = this.handleIcon.bind(this);
        this.updateRowsForGestioneDuplicatiHIV =
            this.updateRowsForGestioneDuplicatiHIV.bind(this);
    }

    isUserOperatoreRegionale =
        SessioneUtente.getInstance().ruoliUtente ===
        Ruoli.Operatore_Regionale.descrizione;

    updateRowsForGestioneDuplicatiHIV = () => {
        // se siamo in gestioneDuplicatiHIV e lo user non è un op_reg - quindi ha una ulss di provenienza
        // allora filtra la matrice considerando solo le sublist che contengono almeno un CU della ULSS di pertinenza
        if (!this.props.gestioneDuplicatiHIV || this.isUserOperatoreRegionale)
            return this.props.rows;
        const ulssAppartenenza = SessioneUtente.getInstance().ulss;
        const filteredMatrix =
            Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(
                this.props.rows
            ).filter((subList) =>
                subList.find((item) => item.appoStruttura === ulssAppartenenza)
            );
        return [].concat(...filteredMatrix);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.rows !== this.props.rows) {
            const updatedRows = this.updateRowsForGestioneDuplicatiHIV();
            this.setState({ rows: updatedRows });
        }
        if (this.props.idFocolaioPadre) {
            let row = this.props.rows.find(focolaio => focolaio.idFocolaio === this.props.idFocolaioPadre);
            if (row) {
                this.handleChangessMonckey(row,true,true,null);
            }
        }
    }

    legend = (
        <div className={styles.legendContainer.concat(" fit-width text")}>
            <div
                className={styles.stickerGreen.concat(
                    " d-inline-block mr-2 ml-3"
                )}
            />{" "}
            Ok
            <div
                className={styles.stickerYellow.concat(
                    " d-inline-block mr-2 ml-3"
                )}
            />{" "}
            In attesa
            <div
                className={styles.stickerRed.concat(
                    " d-inline-block mr-2 ml-3"
                )}
            />{" "}
            Revocato
            <div
                className={styles.stickerGrey.concat(
                    " d-inline-block mr-2 ml-3"
                )}
            />{" "}
            Sospeso
        </div>
    );

    render() {
        if (this.props.page + 1 && this.props.page !== this.state.page) {
            this.setState({ page: this.props.page });
        }

        return (
            <>
                <div className={styles.tableTitle}>{this.props.title}</div>
                <div
                    className={styles.azDiv
                        .concat(" ")
                        .concat(styles.scrollCols)}
                >
                    {!this.props.gestioneDuplicatiHIV &&
                        this.createPageLengthSelect()}
                    <div>
                        {this.createTable()}
                        {this.props.homepage && this.legend}
                    </div>
                </div>
                <div>
                    {!this.props.gestioneDuplicatiHIV && this.createPagination()}
                </div>
                <div className={styles.informationLegend}>
                    {this.props.information ? this.informationTable() : ""}
                </div>
            </>
        );
    }

    informationTable() {
        let boxPallino = [];

        for (let i = 0; i < this.props.information.length; i++) {
            boxPallino.push(
                <tr key={i}>
                    <td className={styles.azTableCell.concat(" noselect")}>
                        <div className={"row"} style={{ marginLeft: "1rem" }}>
                            {this.props.information[i] === "02" ||
                            this.props.information[i] === "05" ||
                            this.props.information[i] === "06" ? (
                                <h3>-</h3>
                            ) : (
                                <div
                                    className={
                                        styles[
                                            OggettiUtili.informazioniTabella[
                                                this.props.information[i]
                                            ].cssClass
                                        ]
                                    }
                                />
                            )}

                            <div
                                style={{
                                    fontSize: "14px",
                                    marginLeft: "10px",
                                    marginTop:
                                        this.props.information[i] === "02" ||
                                        this.props.information[i] === "05" ||
                                        this.props.information[i] === "06"
                                            ? "11px"
                                            : "",
                                }}
                            >
                                {
                                    OggettiUtili.informazioniTabella[
                                        this.props.information[i]
                                    ].Descrizione
                                }
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }

        return boxPallino;
    }

    createPageLengthSelect() {
        return (
            <>
                {this.state.lengthEditable ? (
                    <div className="dataTables_length bs-select">
                        <span style={{ fontSize: "16px" }}>
                            <label>Mostra&nbsp;</label>
                            <select
                                name="test_length"
                                defaultValue={
                                    this.props.tableLenght
                                        ? this.props.tableLenght
                                        : "10"
                                }
                                onChange={this.changePagination}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>{" "}
                            risultati
                        </span>
                    </div>
                ) : null}
            </>
        );
    }

    changePagination = (event) => {
        if (this.props.changePagination) {
            this.props.changePagination(
                this.getActualSort() ? this.getActualSort().col : null,
                this.getActualSort() ? this.getActualSort().direction : null,
                // this.props.page,
                0,
                event.target.value
            );

            let newSize = event.target.value;
            this.setState({ editedSize: newSize, page: this.props.page });
        } else {
            let newSize = event.target.value;
            //if the selected number of el is > of current els, fix table size to num of els to avoid flickering
            this.state.rows.length > newSize
                ? this.setState({ tableLenght: newSize, page: 0 })
                : this.setState({
                      tableLenght: this.state.rows.length,
                      page: 0,
                  });
        }
    };

    createTable() {
        return (
            <table
                className={styles.azTable}
                style={{ minHeight: "100px" }}
                id={"az-table"}
            >
                <thead className={styles.azTableHeader}>
                    <tr>
                        {this.props.empty
                            ? this.createHeadersEmpty()
                            : this.props.homepage
                            ? this.createHeadersButton()
                            : this.createHeaders()}
                    </tr>
                </thead>
                <tbody className={styles.azTableBody}>
                    {this.props.empty ||
                    (this.state.rows && this.state.rows.length == 0) ? (
                        <tr>
                            <td
                                colSpan={
                                    this.props.reportStatistici
                                        ? this.props.cols.length
                                        : this.state.cols.length
                                }
                            >
                                {this.props.emptyMsg}
                            </td>
                        </tr>
                    ) : (
                        this.createRows()
                    )}
                </tbody>
            </table>
        );
    }

    createHeaders() {
        const { t } = this.props;
        //var cols = this.state.cols ? this.state.cols : this.props.cols
        let cols;
        if (this.props.reportStatistici) cols = this.props.cols;
        else cols = this.state.cols;
        return cols.map((el, i) => {
            if (!el["sortDirection"]) {
                return (
                    <th
                        className={styles.azTableHeaderCellMinWidth.concat(
                            " noselect"
                        )}
                        style={{ cursor: "default", minWidth: "125px" }}
                        key={i}
                    >
                        <div className={"row"}>
                            <div
                                className={
                                    "col-10 d-flex align-items-center justify-content-center"
                                }
                                style={{ margin: "10px" }}
                            >
                                {t(el.name)}
                            </div>
                            <div className={"col-2 d-flex align-items-center "}>
                                <span></span>
                            </div>
                        </div>
                    </th>
                );
            } else {
                return this.props.homePage ? (
                    <th
                        className={styles.azTableHeaderCellMinWidthHomePage.concat(
                            " noselect"
                        )}
                        onClick={() => this.setRows(el, i)}
                        key={i}
                    >
                        {this.props.rapporto ? (
                            cols[i].key === "15-24F" ||
                            cols[i].key === "15-22F" ? (
                                <p
                                    style={{
                                        fontSize: "16px",
                                        marginLeft: "65px",
                                    }}
                                >
                                    {t("tableReport.sessoF")}
                                </p>
                            ) : cols[i].key === "15-24M" ||
                              cols[i].key === "15-22M" ? (
                                <span
                                    style={{
                                        fontSize: "16px",
                                        marginLeft: "65px",
                                    }}
                                >
                                    {t("tableReport.sessoM")}
                                </span>
                            ) : null
                        ) : null}
                        <div
                            className={
                                "align-items-center justify-content-center"
                            }
                            style={{ display: "flex", margin: "auto" }}
                        >
                            <span
                                style={
                                    this.props.rapporto
                                        ? cols[i].key === "15-24F" ||
                                          cols[i].key === "15-22F" ||
                                          cols[i].key === "15-24M" ||
                                          cols[i].key === "15-22M"
                                            ? { paddingTop: "15px" }
                                            : { marginTop: "40px" }
                                        : {}
                                }
                            >
                                {t(el.name)}
                            </span>

                            <span
                                style={
                                    this.props.rapporto
                                        ? cols[i].key === "15-24F" ||
                                          cols[i].key === "15-22F" ||
                                          cols[i].key === "15-24M" ||
                                          cols[i].key === "15-22M"
                                            ? { paddingTop: "15px" }
                                            : { marginTop: "40px" }
                                        : {}
                                }
                            >
                                {el["sortDirection"] === "none" && (
                                    <Icon
                                        classes={"w3-small"}
                                        path={"img/icons/sort_both.png"}
                                    />
                                )}
                                {el["sortDirection"] === "asc" && (
                                    <Icon
                                        id={"it-arrow-up-triangle"}
                                        classes="mt-1"
                                    />
                                )}
                                {el["sortDirection"] === "desc" && (
                                    <Icon
                                        id={"it-arrow-down-triangle"}
                                        classes="mb-1"
                                    />
                                )}
                            </span>
                        </div>
                    </th>
                ) : (
                    <th
                        className={styles.azTableHeaderCellMinWidth.concat(
                            " noselect"
                        )}
                        onClick={() => this.setRows(el, i)}
                        key={i}
                    >
                        <div
                            className={
                                "align-items-center justify-content-center"
                            }
                        >
                            {t(el.name)}
                            <span>
                                {el["sortDirection"] === "none" && (
                                    <Icon
                                        classes={"w3-small"}
                                        path={"img/icons/sort_both.png"}
                                    />
                                )}
                                {el["sortDirection"] === "asc" && (
                                    <Icon
                                        id={"it-arrow-up-triangle"}
                                        classes="mt-1"
                                    />
                                )}
                                {el["sortDirection"] === "desc" && (
                                    <Icon
                                        id={"it-arrow-down-triangle"}
                                        classes="mb-1"
                                    />
                                )}
                            </span>
                        </div>
                    </th>
                );
            }
        });
    }

    createHeadersEmpty() {
        //var cols = this.state.cols ? this.state.cols : this.props.cols
        let cols;
        if (this.props.reportStatistici) cols = this.props.cols;
        else cols = this.state.cols;

        return cols.map((el, i) => {
            return (
                <th
                    className={styles.azTableHeaderCell.concat(" noselect")}
                    key={i}
                >
                    <span>
                        {this.props.t(el.name)}
                        {el["sortDirection"] === "NONE" && (
                            <Icon
                                path={"img/icons/sort_both.png"}
                                classes={"ml-2"}
                            />
                        )}
                    </span>
                </th>
            );
        });
    }

    createHeadersButton() {
        let cols = this.state.cols ? this.state.cols : this.props.cols;
        const { t } = this.props;
        return cols.map((el, i) => {
            if (!el["sortDirection"]) {
                return (
                    <th
                        key={i}
                        className={styles.azTableHeaderCellMinWidth.concat(
                            " noselect"
                        )}
                        style={{ cursor: "default", minWidth: "125px" }}
                    >
                        {t(el.name)}{" "}
                    </th>
                );
            } else {
                return (
                    <th
                        key={i}
                        style={{ minWidth: "125px" }}
                        className={styles.azTableHeaderCell.concat(" noselect")}
                        onClick={() => this.setRows(el, i)}
                    >
                        <span>
                            {t(el.name)}
                            {el["sortDirection"] === "none" && (
                                <Icon
                                    path={"img/icons/sort_both.png"}
                                    classes={"ml-2"}
                                />
                            )}
                            {el["sortDirection"] === "asc" && (
                                <Icon
                                    id={"it-arrow-up-triangle"}
                                    classes="mt-1"
                                />
                            )}
                            {el["sortDirection"] === "desc" && (
                                <Icon
                                    id={"it-arrow-down-triangle"}
                                    classes="mb-1"
                                />
                            )}
                        </span>
                    </th>
                );
            }
        });
    }

    setRows(sortColumn, i) {
        //Se ho la paginazione backend, richiedo la pagina attuale con i parametri di ordinamento aggiornati
        if (this.props.changePage) {
            //ordinamento con richiesta della nuova pagina al backend
            this.getSortDirection(sortColumn, i);
            console.log("[DEBUG] Changing page to page: " + this.state.page);
            this.props.changePage(
                this.getActualSort().col,
                this.getActualSort().direction,
                this.state.page,
                this.state.tableLenght
            );
        } else {
            //ordinamento frontend
            let updateRows = this.props.gestioneDuplicatiHIV
                ? this.sortMatrix(
                      sortColumn.key,
                      this.getSortDirection(sortColumn, i)
                  )
                : this.sortRows(
                      this.state.initialRows,
                      sortColumn.key,
                      this.getSortDirection(sortColumn, i)
                  );
            this.setState({ rows: updateRows });
        }
    }

    sortMatrix = (sortColumn, sortDirection) => {
        // definisci il sorting param in base alla colonna
        let sortingFunction = Utils.sortByCodiceUnivoco;
        switch (sortColumn) {
            case "progressivoRegistro":
                sortingFunction = Utils.sortByProgressivoRegistro;
                break;
            case "codiceStruttura":
                sortingFunction = Utils.sortByCodiceStruttura;
                break;
            case "dataSegnalazione":
                sortingFunction = Utils.sortByDataSegnalazione;
                break;
            default:
                break;
        }
        let matrix = Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(
            this.state.rows
        );
        // ogni sublist viene sorted per sorting key, nosense per codiceUnivoco perché è la sublist
        if (sortColumn !== "codiceIndividualePaziente") {
            matrix.forEach((sublist) => sublist.sort(sortingFunction));
            // if sorting desc reverse
            if (sortDirection === "desc")
                matrix.forEach((sublist) => sublist.reverse());
            return [].concat(...matrix);
            // con codiceUnivoco ordina le sublist in matrix per sorting key
        } else {
            const firstChildSublist = matrix.map((sublist) => sublist[0]);
            firstChildSublist.sort(sortingFunction);
            if (sortDirection === "desc") firstChildSublist.reverse();
            let output = [];
            firstChildSublist.forEach((firstChild) => {
                output.push(
                    matrix.find(
                        (sublist) =>
                            sublist[0].progressivoRegistro ===
                            firstChild.progressivoRegistro
                    )
                );
            });
            return [].concat(...output);
        }
    };

    sortRows = (initialRows, sortColumn, sortDirection) => {
        const comparer = (a, b) => {
            if (sortDirection === "asc") {
                return a[sortColumn] > b[sortColumn] ? 1 : -1;
            } else if (sortDirection === "desc") {
                return a[sortColumn] < b[sortColumn] ? 1 : -1;
            }
        };

        return sortDirection === "none"
            ? initialRows
            : [...this.state.rows].sort(comparer);
    };

    getSortDirection(col, i) {
        let newDirection;
        let actualDirection = col["sortDirection"];
        let newCols;
        if (this.props.reportStatistici) newCols = this.props.cols;
        else newCols = this.state.cols;

        //Reset all sortings
        newCols.forEach((el) => {
            if (el["sortDirection"]) {
                el["sortDirection"] = "none";
            }
        });

        //Set new sorting

        //NONE direction NOT present
        if (actualDirection === "none" || actualDirection === "desc") {
            newDirection = "asc";
            newCols[i]["sortDirection"] = newDirection;
        } else {
            newDirection = "desc";
            newCols[i]["sortDirection"] = newDirection;
        }

        this.setState({ cols: newCols });

        return newDirection;
    }

    createRows() {
        let rows = [];

        if (!this.props.totalPages) {
            rows =
                this.state.rows &&
                this.state.rows.slice(
                    this.state.page * this.state.tableLenght,
                    (this.state.page + 1) * this.state.tableLenght
                );
        } else {
            if (this.props.reportStatistici) rows = this.props.rows;
            else rows = this.state.rows;
        }

        let cols;
        if (this.props.reportStatistici) cols = this.props.cols;
        else cols = this.state.cols;

        // se siamo in gestione duplicati ogni item è comparato con la sublist con lo stesso CU
        // se la row ha progressivo identico al primo elemento della sublist è speciale
        const matrix = this.props.gestioneDuplicatiHIV
            ? Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(rows)
            : undefined;
        return rows.map((row, i) => {
            const sublist = matrix
                ? matrix.find(
                      (sublist) =>
                          sublist[0].codiceIndividualePaziente ===
                          row.codiceIndividualePaziente
                  )
                : undefined;
            const isFirst = sublist
                ? row.progressivoRegistro === sublist[0].progressivoRegistro
                : undefined;
            return (
                <tr
                    id={i}
                    className={`${styles.azRow} ${
                        isFirst ? styles.azSpecialRowFirst : ""
                    }`}
                    key={i}
                >
                    {cols.map((col) => this.renderCell(row, col, i))}
                </tr>
            );
        });
    }

    handleRadioClick(value) {
        if (this.props.onButtonSelect) {
            this.props.onButtonSelect(this.state.rows[value.currentTarget.id]);
        }

        if (this.props.onRadioButtonSelect)
            this.props.onRadioButtonSelect(this.state.rows[value]);

        this.setState({
            selezioneFromRadioButton: this.state.rows[value],
        });
    }

    handleConfermaModale(rowIndex) {
        if (this.props.onModalConferma) {
            this.props.onModalConferma(this.state.rows[rowIndex]);
        }
    }

    handleButton(index) {
        if (this.props.onButtonSelect) {
            this.props.onButtonSelect(this.state.rows[index.currentTarget.id]);
        }
    }

    handleIcon(row, event) {
        if (this.props.onClickIcon) {
            this.props.onClickIcon(row, event);
        }
    }

    handleChangessMonckey(row, value, isRadio, fieldName) {
        let updatedRows = this.props.rows;
        let keyField = "checked";
        if (fieldName) keyField = fieldName;

        if (isRadio) {
            for (let i in updatedRows) {
                if (i !== updatedRows.indexOf(row).toString())
                    updatedRows[i][keyField] = false;
                else
                    updatedRows[i][keyField] = true;
            }
        }

        this.setState({
            selected: value === true ? this.state.rows[row] : null,
            rows: updatedRows,
        });

        if (this.props.onSelectCheckbox)
            this.props.onSelectCheckbox(row, value, keyField);
    }

    handleChangess(row, value, isRadio, fieldName) {
        let updatedRows = this.state.rows;
        let keyField = "checked";
        if (fieldName) keyField = fieldName;

        if (isRadio) {
            for (let i in updatedRows) {
                if (i != row) updatedRows[i][keyField] = false;
            }
        }

        this.setState({
            selected: value === true ? this.state.rows[row] : null,
            rows: updatedRows,
        });

        if (this.props.onSelectCheckbox)
            this.props.onSelectCheckbox(this.state.rows[row], value, keyField);
    }

    renderCell(row, el, index) {
        let cell;
        let realRowIndex;
        const { t } = this.props;
        const azTableCell = this.props.homePage === true && row["integrataLIS"] && row["integrataLIS"] === true ? styles.azTableCellAzure:  this.props.homePage === true && row["idoneitaPremal"] && row["idoneitaPremal"].idoneita === false ? styles.azTableCellRed :styles.azTableCell;

        if (this.props.changePage) {
            realRowIndex = index;
        } else {
            realRowIndex = this.state.page * this.state.tableLenght + index;
        }

        // fai una deep copy dell'oggetto così da non modificare l'originale
        el = JSON.parse(JSON.stringify(el));
        // se siamo in gestioneDuplicatiHIV, se l'operatore non è regionale, se la ULSS di appartenenza non è la ULSS della row
        // elimina il link
        const ulssAppartenenza = SessioneUtente.getInstance().ulss;
        if (
            this.props.gestioneDuplicatiHIV &&
            el.key === "progressivoRegistro" &&
            !this.isUserOperatoreRegionale &&
            ulssAppartenenza !== row.appoStruttura
        ) {
            el["tipo"] = undefined;
        }

        if (el["tipo"] === "link") {
            let nomeParametro = el["nomeParametro"];
            let customState = el["state"] ? el["state"] : null;
            let label = el.label ? el.label : row[el.key];
            let param = el.nomeParametro ? row[el.nomeParametro] : row[el.key];

            cell = (
                <td key={el.key} className={azTableCell}>
                    {row["malattia"] === "0413" &&
                    row["pdfAssociato"] === "01" &&
                    el["key"] === "prosegui"
                        ? null
                        : el.notShown && row[el.notShown.field] === el.notShown.conditionValue
                        ? null
                        : (
                        <Link
                            to={{
                                pathname: el["path"],
                                [nomeParametro]: param,
                                state: customState,
                            }}
                            onClick={(e) => {
                                if (el.key === "prosegui" || el.key === "idSegnalazioneLabel") {
                                    // Caso 1: se idSegnalazione === "null     null" → chiama inserisciNuova
                                    if (
                                        !row.idSegnalazione || 
                                        row.idSegnalazione.trim() === "null null" || 
                                        row.idSegnalazione.trim() === "null" || 
                                        row.idSegnalazione.trim() === "null     null"
                                        ) {
                                        e.preventDefault(); // blocca la navigazione del link
                                        console.log("👉 Click Prosegui: chiamo inserisciNuova per LIS");
                                        this.props.inserimentoSegnalazioni(row);
                                    } 
                                    // Caso 2: altrimenti comportati normalmente
                                    else {
                                        console.log("👉 Click Prosegui: navigazione standard");
                                    }
                                }
                            }}
                        >
                            <span style={{ marginLeft: "5px", cursor: "pointer" }}>{label}</span>
                        </Link>

                        )}
                </td>
            );
        }

        else if (el["tipo"] === "pallino") {
            let stato = row[el.key]; //codice dello stato del pallino da mostrare
            let oggetto = el["oggetto"];
            let sticker = oggetto
                ? stato
                    ? oggetto[stato]
                        ? oggetto[stato].cssClass
                            ? oggetto[stato].cssClass
                            : null
                        : null
                    : null
                : null;
            let pallino =
                el.notShown &&
                row[el.notShown.field] ===
                    el.notShown.conditionValue ? null : sticker ? (
                    <div className={"col-3 d-flex align-items-center"}>
                        <a>
                            <div className={styles[sticker]} />
                        </a>
                    </div>
                ) : null;

            cell =
                el.notShown &&
                row[el.notShown.field] === el.notShown.conditionValue ? (
                    <td
                        key={el.key}
                        className={azTableCell.concat(" noselect")}
                        style={{ textAlign: "center" }}
                    >
                        <div className={"row"}>
                            <div
                                className={
                                    "col-10 d-flex align-items-center justify-content-center"
                                }
                            >
                                <h3>-</h3>
                            </div>
                        </div>
                    </td>
                ) : (
                    <td
                        key={el.key}
                        className={azTableCell.concat(" noselect")}
                    >
                        {oggetto &&
                        stato &&
                        oggetto[stato] &&
                        oggetto[stato].sNome ? (
                            <div className={"row"}>
                                <div
                                    className={
                                        "col-9 d-flex align-items-center justify-content-center"
                                    }
                                >
                                    {oggetto[stato].sNome}
                                </div>
                                {pallino}
                            </div>
                        ) : (
                            <div className={"row"}>
                                <div
                                    className={
                                        "col-9 d-flex align-items-center justify-content-center"
                                    }
                                >
                                    {pallino}
                                </div>
                            </div>
                        )}
                    </td>
                );
        } else if (el["tipo"] === "checkbox") {
            let disabled = false;
            if (this.props.disableCheckbox) {
                disabled = this.props.disableCheckbox(row, el["key"]);
            }
            cell = (
                <td key={el.key}>
                    <CheckBox
                        id={"checkbox_" + realRowIndex + el["key"]}
                        index={realRowIndex}
                        isRadio={el["isRadio"]} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                        deselectStyle={el["deselect"]} //prop aggiuntiva che determina stile e comportamento della checkbox: quando la deseleziono, la riga corrispondente viene eliminata
                        parentClass={styles.azTableCellCheckbox}
                        checked={row[el["key"]]}
                        row={row}
                        fieldName={el["key"]}
                        disabledFlag={disabled}
                        onChange={this.handleChangess}
                    ></CheckBox>
                </td>
            );
        } else if (el["tipo"] === "modale") {
            cell = (
                <td key={el.key}  className={row["nuovoInserimento"] && row["nuovoInserimento"] === true?styles.azTableCellYellow:''}>
                    <Modale
                        id={"modale" + realRowIndex}
                        typeModal="modalConsenso"
                        modalText={t(el["modalContent"]["text"])}
                        text={
                            el["modalContent"]["buttonText"]
                                ? el["modalContent"]["buttonText"]
                                : null
                        }
                        icon={
                            el["modalContent"]["buttonIcon"]
                                ? el["modalContent"]["buttonIcon"]
                                : null
                        }
                        classes={
                            el["modalContent"]["buttonClass"]
                                ? el["modalContent"]["buttonClass"]
                                : ""
                        }
                        title={
                            el["modalContent"]["title"]
                                ? el["modalContent"]["title"]
                                :"Elimina Segnalazione"}
                        style={
                            el["modalContent"]["style"]
                                ? el["modalContent"]["style"]
                                :""
                        }
                        textButtonOk={t(el["modalContent"]["conferma"])}
                        textButtonKo={t(el["modalContent"]["annulla"])}
                        confirmFun={(e) => {
                            this.handleConfermaModale(realRowIndex);
                        }}
                    />
                </td>
            );
        } else if (el["tipo"] === "dizionario") {
            let codice;

            codice = row[el.key];

            let oggetto = el["oggetto"];
            let campo = el["campo"];
            cell = (
                <td key={el.key} className={azTableCell.concat(" noselect")}>
                    <span
                    // style={{ marginLeft: "-14px" }}
                    >
                        {oggetto
                            ? codice
                                ? oggetto[codice]
                                    ? campo
                                        ? oggetto[codice][campo]
                                        : oggetto[codice]
                                    : codice
                                : ""
                            : ""}
                    </span>
                </td>
            );
        } else if (el["tipo"] === "radiobutton") {
            cell = (
                <td key={el.key}>
                    <RadioButton
                        id={"tableRadioButton" + realRowIndex}
                        name={"tableRadioButtons"}
                        onClick={this.handleRadioClick}
                        value={index}
                        checked={
                            this.state.selezioneFromRadioButton
                                ? this.state.rows[realRowIndex][
                                      el["identifierName"]
                                  ] ==
                                  this.state.selezioneFromRadioButton[
                                      el["identifierName"]
                                  ]
                                    ? true
                                    : false
                                : this.state.rows[realRowIndex][
                                      el["identifierName"]
                                  ]
                                ? true
                                : false
                        }
                    ></RadioButton>
                </td>
            );
        } else if (el["tipo"] == "linkButton") {
            let nomeParametro = el["nomeParametro"];

            let label = el.label ? el.label : row[el.key];

            cell = (
                <td key={el.key} className={row["nuovoInserimento"] && row["nuovoInserimento"]==true?styles.azTableCellYellow:''}>
                    <Button
                        id={index}
                        classes="btn btnBluOutline "
                        onClick={this.handleButton}
                        style={{
                            outline: "none !important",
                            border: "none",
                            background: "none",
                            fontSize: "16px",
                            color: "#1b7ea9",
                            textDecoration: "underline",
                        }}
                        text={
                            nomeParametro ??
                            this.props.t(
                                "Tables.reportStatistici.visualizzaGrafico"
                            )
                        }
                    >
                        <span style={{ marginLeft: "5px", cursor: "pointer" }}>
                            {label}
                        </span>
                    </Button>
                </td>
            );
        } else if (el["tipo"] == "icon") {
            let id = row[el.idElemento];

            cell = (
                <td key={el.key}>
                    <span
                        id={el.id + id}
                        onClick={(event) => this.handleIcon(row, event)}
                    >
                        <Icon
                            style={el.style}
                            id={el.id}
                            classes={el.classes}
                        />
                    </span>
                </td>
            );
        } else if (el["tipo"] == "data") {
            cell = (
                <td
                    key={el.key}
                    className={azTableCell.concat(" noselect")}
                    style={{ textAlign: "center" }}
                >
                    <span>{Utils.transformDateForFrontend(row[el.key])}</span>
                </td>
            );
        } else if (el["tipo"] == "tooltip") {
            if (row[el.key] === null) {
                cell = (
                    <td key={el.key}>
                        <Icon
                            style={{ fill: "#000000" }}
                            id={"it-minus"}
                            classes={"icon-sm"}
                        />
                    </td>
                );
            } else {
                let element;
                let errorString = "";
                if (row[el.key].length > 15) {
                    element = row[el.key].slice(2, 14) + "...";
                    errorString = row[el.key].toString().replace("|", "•");
                    errorString = errorString.replaceAll(" |", "\n•");
                } else {
                    element = row[el.key];
                }
                cell = (
                    <td
                        key={el.key}
                        style={{
                            width: "200px"
                        }}
                        className={
                            this.props.tooltipTable
                                ? styles.azTableCellTwo
                                      .concat(" noselect ")
                                      .concat(styles.tooltipTable)
                                : styles.azTableCellTwo.concat(" noselect")
                        }
                    >
                        <div className={"row"}>
                            <div
                                className={
                                    "col-8 d-flex align-items-center justify-content-center"
                                }
                            >
                                <div className={styles.tooltip}>
                                    {element}
                                    {errorString === "" ? "" :
                                        <span className={styles.tooltiptext}>
                                            {errorString}
                                        </span>}
                                </div>
                            </div>
                            <span
                                title={"Copia"}
                                className={"col-4 d-flex align-items-center"}
                                onClick={() => navigator.clipboard.writeText(
                                    row[el.key]
                                )}
                            >
                                <Icon
                                    style={{
                                        fill: "#1b7ea9",
                                        cursor: "pointer",
                                    }}
                                    id={"it-copy"}
                                    classes={"icon-sm"}
                                />
                            </span>
                        </div>
                    </td>
                );
            }
        } else if (this.state.bigTable === true) {
            const matrix =
                this.props.gestioneDuplicatiHIV &&
                el.key === "codiceIndividualePaziente"
                    ? Utils.retrieveMatrixFromListPerGestioneDuplicatiHiv(
                          this.state.rows
                      )
                    : undefined;
            const sublist = matrix
                ? matrix.find(
                      (sublist) =>
                          sublist[0].codiceIndividualePaziente ===
                          row.codiceIndividualePaziente
                  )
                : undefined;
            const isNotFirst = sublist
                ? row.progressivoRegistro !== sublist[0].progressivoRegistro
                : undefined;
            cell = (
                <td
                    key={el.key}
                    style={{ maxWidth: this.props.tooltipTable ? "100px" : "" }}
                    className={
                        isNotFirst
                            ? styles.notFirst
                            : this.props.tooltipTable
                            ? styles.azTableCellTwo
                                  .concat(" noselect ")
                                  .concat(styles.tooltipTable)
                            : azTableCell.concat(" noselect")
                    }
                >
                    <span
                        style={{
                            display:
                                el.key === "scadenza" &&
                                row["statoSegnalazione"] === "99"
                                    ? "none"
                                    : null,
                        }}
                    >
                        {row[el.key]}
                    </span>
                </td>
            );
        } else {
            cell = (
                <td
                    key={el.key}
                    style={{ maxWidth: this.props.tooltipTable ? "100px" : "" }}
                    className={row["nuovoInserimento"] && row["nuovoInserimento"]==true?
                        this.props.tooltipTable
                            ? styles.azTableCellTwo
                                  .concat(" noselect ")
                                  .concat(styles.tooltipTable).concat(" "+styles.azTableCellYellow)
                            : styles.azTableCellTwo.concat(" noselect").concat(" "+styles.azTableCellYellow):

                            this.props.tooltipTable
                            ? styles.azTableCellTwo
                                  .concat(" noselect ")
                                  .concat(styles.tooltipTable)
                            : styles.azTableCellTwo.concat(" noselect")
                    }
                >
                    <span
                        style={{
                            display:
                                el.key === "scadenza" &&
                                row["statoSegnalazione"] === "99"
                                    ? "none"
                                    : null,
                        }}
                    >
                        {row[el.key]}
                    </span>
                </td>
            );
        }

        return cell;
    }

    createPagination() {
        let totalPages;
        if (this.props.pagination) {
            if (this.props.empty) return <></>;
            else {
                if (this.props.totalPages) {
                    totalPages = this.props.totalPages;
                } else {
                    totalPages =
                        this.state.rows.length / this.state.tableLenght;
                }
            }
        } else {
            return <></>;
        }
        let pageNumbers = [];
        totalPages = Math.ceil(totalPages);
        let lastPage = Math.floor(totalPages - 1);
        totalPages &&
            pageNumbers.push(
                <li key={0} className="page-item">
                    {this.state.page === 0 && (
                        <a className="page-link" aria-current="page">
                            {this.state.page + 1}
                        </a>
                    )}
                    {this.state.page > 0 && this.state.page !== lastPage && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page - 1)}
                        >
                            {this.state.page}
                        </a>
                    )}
                    {totalPages === 2 && this.state.page === lastPage && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page - 1)}
                        >
                            {this.state.page}
                        </a>
                    )}
                    {totalPages !== 2 &&
                        this.state.page === lastPage &&
                        this.state.page !== 0 && (
                            <a
                                className="page-link"
                                onClick={() =>
                                    this.changePage(this.state.page - 2)
                                }
                            >
                                {this.state.page - 1}
                            </a>
                        )}
                </li>
            );

        totalPages > 1 &&
            pageNumbers.push(
                <li key={1} className="page-item">
                    {this.state.page === 0 && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page + 1)}
                        >
                            {this.state.page + 2}
                        </a>
                    )}
                    {this.state.page > 0 && this.state.page !== lastPage && (
                        <a className="page-link" aria-current="page">
                            {this.state.page + 1}
                        </a>
                    )}
                    {totalPages === 2 && this.state.page === lastPage && (
                        <a className="page-link" aria-current="page">
                            {this.state.page + 1}
                        </a>
                    )}
                    {totalPages !== 2 && this.state.page === lastPage && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page - 1)}
                        >
                            {this.state.page}
                        </a>
                    )}
                </li>
            );

        totalPages > 2 &&
            pageNumbers.push(
                <li key={2} className="page-item">
                    {this.state.page === 0 && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page + 2)}
                        >
                            {this.state.page + 3}
                        </a>
                    )}
                    {this.state.page > 0 && this.state.page !== lastPage && (
                        <a
                            className="page-link"
                            onClick={() => this.changePage(this.state.page + 1)}
                        >
                            {this.state.page + 2}
                        </a>
                    )}
                    {this.state.page === lastPage && (
                        <a className="page-link" aria-current="page">
                            {this.state.page + 1}
                        </a>
                    )}
                </li>
            );

        let toRender = null;

        this.props.nascondiPaginazione
            ? (toRender = <div></div>)
            : (toRender = (
                  <div
                      className={styles.paginationContainer.concat(
                          " fit-width"
                      )}
                  >
                      <ul className="pagination mt-2">
                          <label
                              style={{ marginTop: "12px", marginRight: "15px" }}
                          >
                              {this.state.editedSize !== 10
                                  ? this.state.editedSize >
                                    this.props.totalElements
                                      ? this.props.totalElements
                                      : (this.state.page + 1) *
                                            this.state.editedSize >
                                        this.props.totalElements
                                      ? this.props.totalElements
                                      : (this.state.page + 1) *
                                        this.state.editedSize
                                  : (this.state.page + 1) *
                                        this.state.tableLenght >
                                    this.props.totalElements
                                  ? this.props.totalElements
                                  : (this.state.page + 1) *
                                    this.state.tableLenght}{" "}
                              di{" "}
                              {this.props.totalElements
                                  ? this.props.totalElements
                                  : this.state.rows.length}
                          </label>
                          <li
                              className="page-item"
                              onClick={() =>
                                  this.state.page === 0
                                      ? null
                                      : this.changePage(0)
                              }
                          >
                              <a
                                  style={{
                                      cursor:
                                          this.state.page === 0
                                              ? "auto"
                                              : "pointer",
                                  }}
                                  className="page-link"
                                  tabIndex="-1"
                                  aria-hidden="true"
                              >
                                  <span
                                      style={{
                                          fontFamily: "Arial",
                                          opacity:
                                              this.state.page === 0
                                                  ? "0.5"
                                                  : "1",
                                      }}
                                  >
                                      Prima
                                  </span>
                              </a>
                          </li>
                          <li
                              className="page-item"
                              onClick={() =>
                                  this.state.page === 0
                                      ? null
                                      : this.changePage(this.state.page - 1)
                              }
                          >
                              <a
                                  style={{
                                      cursor:
                                          this.state.page === 0
                                              ? "auto"
                                              : "pointer",
                                  }}
                                  className="page-link"
                                  tabIndex="-1"
                                  aria-hidden="true"
                              >
                                  <span
                                      className="sr-only"
                                      style={{ fontFamily: "Arial" }}
                                  >
                                      Pagina precedente
                                  </span>
                                  <Icon
                                      style={{
                                          opacity:
                                              this.state.page === 0
                                                  ? "0.5"
                                                  : "1",
                                      }}
                                      id={"it-chevron-left"}
                                  />
                              </a>
                          </li>
                          {pageNumbers}
                          <li
                              className="page-item"
                              onClick={() =>
                                  this.state.page === lastPage
                                      ? null
                                      : this.changePage(this.state.page + 1)
                              }
                          >
                              <a
                                  style={{
                                      cursor:
                                          this.state.page === lastPage
                                              ? "auto"
                                              : "pointer",
                                  }}
                                  className="page-link"
                              >
                                  <span className="sr-only">
                                      Pagina successiva
                                  </span>
                                  <Icon
                                      style={{
                                          opacity:
                                              this.state.page === lastPage
                                                  ? "0.5"
                                                  : "1",
                                      }}
                                      id={"it-chevron-right"}
                                  />
                              </a>
                          </li>
                          <li
                              className="page-item"
                              onClick={() =>
                                  this.state.page === lastPage
                                      ? null
                                      : this.changePage(lastPage)
                              }
                          >
                              <a
                                  style={{
                                      cursor:
                                          this.state.page === lastPage
                                              ? "auto"
                                              : "pointer",
                                  }}
                                  className="page-link"
                                  tabIndex="-1"
                                  aria-hidden="true"
                              >
                                  <span
                                      style={{
                                          fontFamily: "Arial",
                                          opacity:
                                              this.state.page === lastPage
                                                  ? "0.5"
                                                  : "1",
                                      }}
                                  >
                                      Ultima
                                  </span>
                              </a>
                          </li>
                      </ul>
                  </div>
              ));
        return toRender;
    }

    getActualSort() {
        let actualSorted;
        if (this.props.reportStatistici) {
            this.props.cols.forEach((col) => {
                if (col.sortDirection && col.sortDirection !== "none") {
                    actualSorted = {
                        col: col.key,
                        direction: col.sortDirection,
                    };
                }
            });
        } else {
            this.state.cols.forEach((col) => {
                if (col.sortDirection && col.sortDirection !== "none") {
                    actualSorted = {
                        col: col.key,
                        direction: col.sortDirection,
                    };
                }
            });
        }

        return actualSorted;
    }

    changePage(newPage) {
        if (this.props.totalPages) {
            if (newPage >= 0 && newPage < this.props.totalPages) {
                if (this.props.changePage) {
                    console.log("[DEBUG] Changing page to page: " + newPage);
                    this.props.changePage(
                        this.getActualSort() ? this.getActualSort().col : null,
                        this.getActualSort()
                            ? this.getActualSort().direction
                            : null,
                        newPage,
                        this.state.tableLenght
                    );
                    return false;
                } else {
                    this.setState({ page: newPage });
                }
            } else console.log("[DEBUG] Invalid page: " + newPage);
        } else {
            if (
                newPage >= 0 &&
                newPage < this.state.rows.length / this.state.tableLenght
            ) {
                this.setState({ page: newPage });
            } else console.log("[DEBUG] Invalid page: " + newPage);
        }
    }

    copyText(element) {
        navigator.clipboard.writeText(element);
    }
}

Table.defaultProps = {
    rows: [],
    initialRows: [],
    tableLenght: 10,
    cols: [],
    homepage: false,
    empty: false,
    lengthEditable: false,
    pagination: true,
    bigTable: false,
    emptyMsg: "Non sono presenti istanze da completare",
};

export default withTranslation("common")(Table);
